import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { validateIntegerInput } from '@gk/gk-modules';
import {
  MCGRNewRequestAdditionalControlName,
  MCGRNewRequestFormGroup,
} from '../services/new-request-form/new-request-form.model';
import {
  MCGROtherConservationActivitiesControlName,
  MCGROtherConservationActivitiesFormGroup,
  OtherConservationActivity,
} from './other-conservation-activities-form-array.model';
import { MCGROtherConservationActivitiesFormArrayService } from './other-conservation-activities-form-array.service';
@Component({
  selector: 'app-mcgr-other-conservation-activities-form-array',
  templateUrl: './other-conservation-activities-form-array.component.html',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule],
})
export class MCGROtherConservationActivitiesFormArrayComponent {
  arrayControlName =
    MCGRNewRequestAdditionalControlName.OtherConservationActivities;
  controlName = MCGROtherConservationActivitiesControlName;
  @Input() formGroup: FormGroup<MCGRNewRequestFormGroup>;
  @Input() submitted: boolean;

  constructor(
    private mcgrOtherConservationActivitiesFormArrayService: MCGROtherConservationActivitiesFormArrayService,
  ) {}

  isFormGroupValid(index: number): boolean {
    const letterContentWithParcelsFormGroup = this.getFormArray().at(index);
    return letterContentWithParcelsFormGroup.valid;
  }

  deleteFormControl(index: number): void {
    this.getFormArray().removeAt(index);
  }

  getFormArray(): FormArray<
    FormGroup<MCGROtherConservationActivitiesFormGroup>
  > {
    return this.formGroup.get(this.arrayControlName) as FormArray<
      FormGroup<MCGROtherConservationActivitiesFormGroup>
    >;
  }

  addFormControl(): void {
    this.getFormArray().push(
      this.mcgrOtherConservationActivitiesFormArrayService.getFormGroup(),
    );
  }

  validateIntegerInput(event: KeyboardEvent): void {
    if (!validateIntegerInput(event.key)) {
      event.preventDefault();
    }
  }

  createFormArrayFromData(dataArray: OtherConservationActivity[]): void {
    const formArray = this.getFormArray();
    formArray?.clear();
    dataArray?.forEach(() => {
      formArray.push(
        this.mcgrOtherConservationActivitiesFormArrayService.getFormGroup(),
      );
    });
  }
}
